export default __webpack_public_path__ + "static/media/L.3dace17f.svg";